import React from 'react';
import { TypographyContext, type TypographyContextValue } from './TypographyContext';

export function useTypography(): TypographyContextValue {
  const context = React.useContext(TypographyContext);
  if (!context) {
    throw new Error('useTypography must be used within a TypographyProvider');
  }
  return context;
}
